import { selectIsInternalAdmin, selectLoggedinUserEmail } from 'accessors'
import Toggle from 'components/ReusableComponents/Toggle/index'
import { userEmailsCanToggleUserDefaultOperaReports } from 'constants/index'
import Box from 'features/Hotel/Box'
import { useSelector } from 'react-redux'

const hotelWebsites = {
  choice: 'choicehotels.com',
  ihg: 'ihg.com',
  radisson: 'radissonhotels.com',
  wyndham: 'wyndhamhotels.com',
  hyatt: 'hyatt.com',
  sonesta: 'sonesta.com',
  marriott: 'marriott.com',
  bestwestern: 'bestwestern.com',
  hilton: 'hilton.com'
}

const HotelPreferences = ({ updateHotelDetails, hotelDetails }) => {
  const {
    isChatBotEnabled,
    pms,
    isJustAutomatedOtaCampaigns,
    usesSavibookBe,
    isJustAutomatedNonMembers
  } = hotelDetails

  const isInternalAdmin = useSelector(selectIsInternalAdmin)

  const userEmail = useSelector(selectLoggedinUserEmail)

  const isSuperAdmin =
    userEmailsCanToggleUserDefaultOperaReports.includes(userEmail) && isInternalAdmin
  hotelDetails.operaDefault = hotelDetails.pms === 'opera' ? true : false

  return (
    <Box title="Preferences">
      <div
        style={{
          display: 'flex',
          marginTop: 5,
          flexDirection: 'column',
          justifyContent: 'flex-start',
          rowGap: 12
        }}
      >
        <div>
          <Toggle
            handleChange={e => updateHotelDetails({ isChatBotEnabled: e.target.checked })}
            checked={isChatBotEnabled}
            label="Use chatbot"
          />
        </div>
        <div>
          <Toggle
            handleChange={e =>
              updateHotelDetails({ IsJustAutomatedOtaCampaigns: e.target.checked })
            }
            checked={isJustAutomatedOtaCampaigns}
            label="Only sends OTA campaigns"
          />
        </div>
        <div>
          <Toggle
            handleChange={e =>
              updateHotelDetails({ IsJustAutomatedNonMembers: e.target.checked })
            }
            checked={isJustAutomatedNonMembers}
            label="Only sends to non-members"
          />
        </div>
        <div>
          <Toggle
            handleChange={e => updateHotelDetails({ usesSavibookBe: e.target.checked })}
            checked={usesSavibookBe}
            label="Use Savibook BE"
          />
        </div>
      </div>
    </Box>
  )
}

export default HotelPreferences
